import { ref, watch } from 'vue'

const STORAGE_KEY = 'executor-workspace-split'

export function useExecutorSplitMode() {
  let storedValue = null
  try {
    storedValue = window.localStorage.getItem(STORAGE_KEY)
  } catch (_error) {
    storedValue = null
  }

  const split = ref(storedValue === 'true')
  watch(split, (value) => {
    try {
      window.localStorage.setItem(STORAGE_KEY, String(value))
    } catch (_error) {
      // Storage may be unavailable in private or restricted browser contexts.
    }
  })
  return { split }
}
